import { mutate } from '../../../../../../../common/graphql/apollo-client';
import { GET_SUBMISSION_QUERY } from '../../gql/submission-graphql';
import { ADMIN_GAME_QUERY } from '../../../../../../../common/graphql/games/game-admin-graphql';
import {
  ADMIN_UPDATE_SUBMISSION_ART_MUTATION,
  AdminSubmissionUpdateArtInput,
  UpdateSubmissionArtMutation,
} from '@crazygames/graph-types/submission/admin-submission-update-art-input.type';

export function updateSubmissionArt(input: AdminSubmissionUpdateArtInput, gameSlug: string) {
  return mutate<AdminSubmissionUpdateArtInput, UpdateSubmissionArtMutation>(ADMIN_UPDATE_SUBMISSION_ART_MUTATION, input, {
    refetchQueries: [
      { query: GET_SUBMISSION_QUERY, variables: { id: input.id } },
      { query: ADMIN_GAME_QUERY, variables: { slug: gameSlug } },
    ],
    awaitRefetchQueries: true,
  });
}
